export const baseURL = "https://skv.moiaccount.in/api";

//export const baseURL = "http://localhost:4041";
